import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconStar(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.6a.9.9 0 0 1 .846.592l1.803 4.959 5.426.452a.9.9 0 0 1 .477 1.607l-4.026 3.132 1.342 4.921a.9.9 0 0 1-1.331 1.009L12 17.55l-4.537 2.722a.9.9 0 0 1-1.331-1.009l1.342-4.92-4.027-3.133a.9.9 0 0 1 .478-1.607l5.426-.452 1.803-4.959A.9.9 0 0 1 12 3.6Zm0 3.534-1.351 3.715-4.276.356 3.153 2.453-1.068 3.918L12 15.45l3.542 2.126-1.068-3.918 3.153-2.453-4.276-.356L12 7.134Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
